<template>
    <section v-if="isContentReady">
        <div class="row">
            <div class="col-12">
                <job-order-step :loadData="loadData"></job-order-step>
            </div>
        </div>
        
        <div class="row" v-show="isShowHeader">
            <div class="col-12">
                <job-order-header :loadData="loadData">ลูกค้าเครดิต</job-order-header>
            </div>
        </div>

        <div class="row">
            <div class="col-12">
                <job-order-customer-fleet
                    @customerReady="customerReady()"
                    @formData="mixinsJobForm_SetupData($event)"
                    :jobState="jobState"
                    :loadData="loadData">
                </job-order-customer-fleet>
            </div>
        </div>

        <div id="panelCustomer" class="row" v-show="isCustomerReady">
            <div class="col-12">
                <job-order-customer 
                    @carInfoReady="carInfoReady()"
                    @formData="mixinsJobForm_SetupData($event)"
                    :jobState="jobState"
                    :loadData="loadData"
                    :errorData="errorData">
                </job-order-customer>
            </div>
        </div>

        <div class="text-center mb-4" v-if="isShowButtonSelectOrder">
            <button class="btn btn-main" @click="showProductBoard()">เลือกสินค้าออเดอร์</button>
        </div>

        <div id="panelProduct" class="row" v-show="isShowProductList" >
            <div class="col-12">
                <job-order-product
                    @formData="mixinsJobForm_SetupData($event)"
                    :jobState="jobState"
                    :loadData="loadData"
                    :errorData="errorData">
                </job-order-product>
            </div>
        </div>

        <div id="panelTurnPart" class="row" v-show="isShowTurnPart" >
            <div class="col-12">
                <job-order-turn-part
                    @formData="mixinsJobForm_SetupData($event)"
                    :jobState="jobState"
                    :loadData="loadData"
                    :errorData="errorData">
                </job-order-turn-part>
            </div>
        </div>

        <div id="panelBill" class="row" v-show="isShowOrderBill">
            <div class="col-12">
                <job-order-bill
                    @formData="mixinsJobForm_SetupData($event)"
                    :jobState="jobState"
                    :loadData="loadData"
                    :errorData="errorData">
                </job-order-bill>
            </div>
        </div>

        <div class="text-center" v-if="isOpenJobAvailable">
            <button class="btn btn-main" @click="openJob()">เปิดใบสั่งซื้อ</button>
        </div>
        <div class="text-center" v-if="jobState === $Constants.JOB_STATUS_PENDING">
            <button class="btn btn-green mr-1" @click="saveJob()">บันทึกใบงาน</button>
            <button class="btn btn-main mr-1" @click="closeJob()">ปิดงานและออกบิล</button>
            <button class="btn btn-red ml-4" @click="cancelJob(loadData)">ยกเลิก</button>
        </div>
        <div class="text-center" v-if="jobState === $Constants.JOB_STATUS_COMPLETE">
            <button class="btn btn-blue mr-1" @click="mixinsJobForm_PrintForm()">PRINT ใบเสร็จ</button>
        </div>

        <print-document ref="refPrintDocument" :printTemplate="$Constants.PRINT_TYPE_RECEIPT"></print-document>
    </section>    
</template>

<script>
import Helper from '@/resources/Helper';
import JobFormMixin from '@/components/job/JobForm';
import JobOrderStep from '@/components/job/order/Step';
import JobOrderHeader from '@/components/job/shared/Header';
import JobOrderCustomerFleet from '@/components/job/order/CustomerFleet';
import JobOrderCustomer from '@/components/job/shared/Customer';
import JobOrderProduct from '@/components/job/order/Product';
import JobOrderTurnPart from '@/components/job/order/TurnPart';
import JobOrderBill from '@/components/job/order/Bill';
import PrintDocument from '@/components/print/PrintTemplate';
import DBJob from '@/database/Job';

export default {
    mixins: [ JobFormMixin ],
    components: {
        JobOrderStep,
        JobOrderHeader,
        JobOrderCustomerFleet,
        JobOrderCustomer,
        JobOrderProduct,
        JobOrderTurnPart,
        JobOrderBill,
        PrintDocument
    },
    data() {
        return {
            isContentReady: false,
            formType: this.$Constants.JOB_FORM_FLEET,
            isShowHeader: false,
            isCustomerReady: false,
            isShowButtonSelectOrder: false,
            isShowProductList: false,
            isShowTurnPart: false,
            isShowOrderBill: false,
            isOpenJobAvailable: false,
            jobState: this.$Constants.JOB_STATUS_NEW,
            loadData: null,
            errorData: null
        }
    },
    mounted() {
        this.initForm();
        this.initErrorData();
    },
    methods: {
        async initForm() {
            const queryStringOrder = Helper.getQueryString('o');

            if (queryStringOrder) {
                const data = await DBJob.getDetailByNumber(queryStringOrder, this.formType);

                if (data) {
                    this.isShowHeader = true;
                    this.isShowProductList = true;
                    this.isShowTurnPart = true;
                    this.isShowOrderBill = true;
                    this.jobState = data.status;
                    this.loadData = data;
                } else {
                    this.$router.push('/404');
                }
            }
            
            this.isContentReady = true;
        },
        initErrorData() {
            this.errorData = {
                customer: this.mixinsJobForm_InitCustomerErrorData(),
                order: this.mixinsJobForm_InitOrderErrorData(),
                turnPartList: this.mixinsJobForm_InitTurnPartErrorData(),
                bill: this.mixinsJobForm_InitBillErrorData(),
                tax: this.mixinsJobForm_InitTaxErrorData()
            };
        },
        customerReady() {
            this.isCustomerReady = true;
        },
        carInfoReady() {
            this.isShowButtonSelectOrder = true;
        },
        showProductBoard() {
            this.isShowButtonSelectOrder = false;
            this.isShowProductList = true;
            this.isShowTurnPart = true;
            this.isOpenJobAvailable = true;
        },
        openJob() {
            this.initErrorData();

            if (this.validateOpenJob()) {
                this.mixinsJobForm_ProceedOpenJob();
            }
        },
        async saveJob() {
            this.initErrorData();

            if (this.validateOpenJob()) {
                this.mixinsJobForm_ProceedUpdateForm();
            }
        },
        closeJob() {
            this.initErrorData();

            if (this.validateCloseJob()) {
                this.$swal({
                    title: 'บริการเสร็จเรียบร้อยแล้ว?',
                    text: 'โปรดยืนยันว่าต้องการปิดใบสั่งงานใบนี้',
                    icon: 'question',
                    showCancelButton: true
                }).then((result) => {
                    if (result.isConfirmed) {
                        this.mixinsJobForm_ProceedCloseJob();
                    }
                });
            }
        },
        cancelJob(data) {
            this.mixinsJobForm_CancelJob(data);
        },
        validateOpenJob() {
            let valid = true;
            let isScrollDone = false;
            this.mixins_ResetScrollToError();

            if (!this.mixins_ValidateCustomer()) {
                valid = false;

                if (!isScrollDone) {
                    this.mixins_ScrollToError('panelCustomer');
                    isScrollDone = true;
                }
            }

            if (!this.mixins_ValidateProduct(this.$Constants.JOB_ACTION_STATE_OPEN)) {
                valid = false;

                if (!isScrollDone) {
                    this.mixins_ScrollToError('panelProduct');
                    isScrollDone = true;
                }
            }

            return valid;
        },
        validateCloseJob() {
            let valid = true;
            let isScrollDone = false;
            this.mixins_ResetScrollToError();

            if (!this.mixins_ValidateCustomer()) {
                valid = false;

                if (!isScrollDone) {
                    this.mixins_ScrollToError('panelCustomer');
                    isScrollDone = true;
                }
            }

            if (!this.mixins_ValidateProduct(this.$Constants.JOB_ACTION_STATE_CLOSE)) {
                valid = false;

                if (!isScrollDone) {
                    this.mixins_ScrollToError('panelProduct');
                    isScrollDone = true;
                }
            }

            if (!this.mixins_ValidateTurnPart()) {
                valid = false;

                if (!isScrollDone) {
                    this.mixins_ScrollToError('panelTurnPart');
                    isScrollDone = true;
                }
            }

            if (!this.mixins_ValidateBill()) {
                valid = false;

                if (!isScrollDone) {
                    this.mixins_ScrollToError('panelBill');
                    isScrollDone = true;
                }
            }

            return valid;
        }
    }
}
</script>